import apiClient from "./apiClient";
import fileApiClient from "./fileApiClient";

export const apiService = {
  get: async <T>(url: string, params?: Record<string, any>): Promise<T> => {
    try {
      const response = await apiClient.get<T>(url, { params });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  post: async <T>(url: string, data?: Record<string, any>): Promise<T> => {
    try {
      const response = await apiClient.post<T>(url, data);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  put: async <T>(url: string, data?: Record<string, any>): Promise<T> => {
    try {
      const response = await apiClient.put<T>(url, data);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  delete: async <T>(url: string, data?: Record<string, any>): Promise<T> => {
    try {
      const response = await apiClient.delete<T>(url, { data });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },
};

export const fileApiService = {
  // GET 요청
  get: async <T>(
    url: string,
    options?: {
      params?: Record<string, any>;
      responseType?: ResponseType;
    }
  ): Promise<T> => {
    try {
      const response = await fileApiClient.get<T>(url, {
        params: options?.params,
        responseType: options?.responseType as any,
      });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  // POST 요청
  post: async <T>(url: string, data?: Record<string, any>): Promise<T> => {
    try {
      const response = await fileApiClient.post<T>(url, data);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },
};
